import { defineMessages } from 'react-intl';


export default defineMessages({
  InputLinkTitle: {
    id: 'app.containers.Video.InputLinkTitle',
    defaultMessage: 'Link do YouTube:',
  },
  ErrorYouTubeMessage: {
    id: 'app.containers.Video.ErrorYouTubeMessage',
    defaultMessage: 'Certifique-se de que um link do YouTube foi digitado',
  },
  DeleteAlertMessage: {
    id: 'app.containers.Video.DeleteAlertMessage',
    defaultMessage: 'Cuidado! Você vai deletar a URL do vídeo',
  },
});
